import { createAction } from "typesafe-actions";

import type {
    ContactDetails,
    ContactsSearchSortBy,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";

// Employee location selection
export const employeeLocationIdsSelectedAction = createAction("@@si/company-analysis/employee-location-ids-selected")<
    readonly number[]
>();

// Employee profiles selection
export const profileModalIsOpenedSetAction = createAction(
    "@@si/company-analysis/profile-modal-is-opened-set",
)<boolean>();
export const setProfileForEditAction = createAction("@@si/company-analysis/set-profile-for-edit")<ProfileDto | null>();
export const profileSelectedAction = createAction("@@si/company-analysis/profile-selected")<string | null>();

// Contact details selection
export const contactDetailsSelectedAction = createAction(
    "@@si/company-analysis/contact-details-selected",
)<ContactDetails>();

// Contacts table filters
export const contactsTableFiltersChangedAction = createAction("@@si/company-analysis/contacts-table-filters-changed")<{
    page?: number;
    searchText?: string;
}>();

export const contactsTableSortByChangedAction = createAction(
    "@@si/company-analysis/contacts-table-sorting-changed",
)<ContactsSearchSortBy>();
